/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseOfferHistoryDesktopRequest,
  TGetHouseOfferHistoryDesktopModel,
  IMappers,
  TGetHouseOfferHistoryDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferHistoryResponseBaseV4 } from '../../entities/offer_history/OfferHistoryResponseBaseV4';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseOfferHistoryDesktopModel(
  parameters: TGetHouseOfferHistoryDesktopRequest,
): TGetHouseOfferHistoryDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v4/get-house-offer-history-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseOfferHistoryDesktopRequest;
}

export async function fetchGetHouseOfferHistoryDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseOfferHistoryDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseOfferHistoryDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetHouseOfferHistoryDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferHistoryResponseBaseV4, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseOfferHistoryDesktopResponse>;
}
